import React from "react";
import Quarter from "./Quarter";
import PlanPanel from "./PlanPanel";

const getLoadingQuarters = function() {
    const result = [];
    for(let i = 0; i < 16; i++) {
        result.push(<Quarter loading/>);
    }
    return result;
}

class Quarters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            plan: props.plan,
            isLoading: props.isLoading
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isLoading !== this.props.isLoading) {
            this.setState({ isLoading: this.props.isLoading, plan: this.props.plan });
        }
    }

    render() {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                {
                    this.state.isLoading
                        ? getLoadingQuarters()
                        : this.state.plan.coursesList.map((quarter, index) =>
                            <Quarter
                                courses={quarter}
                                addCourseToPlan={(courseCode) => {this.props.addCourseToPlan(this.state.plan._id, index, courseCode)}}
                                moveCourse={this.props.moveCourse}
                                removeCourse={(courseCode, isToQuarter) => this.props.removeCourseFromPlan(this.state.plan._id, index, courseCode, isToQuarter)}
                                getCourseUnit={this.props.getUnits.getCourseUnit}
                                getQuarterTotalUnit={() => this.props.getUnits.getQuarterTotalUnit(this.state.plan._id, index)}
                                setIsDragging={this.props.setIsDragging}
                            />
                        )
                }
            </div>
        );
    }
}

export default Quarters;